<app-tool-loader [isLoading]="isLoading()">
  <form [formGroup]="form.formGroup">
    <p-panel>
      <ng-template pTemplate="header">
        <div class="flex flex-col items-center m-2 w-full">
          <label class="mr-2">Internal Pressure</label>
          <p-select
            [disabled]="isReadOnly"
            [options]="ipps"
            [formControlName]="form.formControlNames.type"
            appendTo="body"
            (onChange)="onIppTypeChange($event)"
          ></p-select>
        </div>
      </ng-template>

      <!--body doesn't have template-->
      <div class="bg-[var(--p-content-background)] p-2">
        @switch (form.formGroup.value.type) {
          @case (InternalPressureProfileType.PERICALLINK) {
            <app-perical-link-ipp
              [formControlName]="form.formControlNames.pericalLinkIpp"
              [thermalOperations]="thermalOperations"
              [userUnits]="userUnits"
            ></app-perical-link-ipp>
          }
          @case (InternalPressureProfileType.DISPLACEMENTFLUID) {
            <app-displacement-fluid-ipp
              [formControlName]="form.formControlNames.displacementFluidIpp"
              [cement]="cement"
              [currentString]="currentString"
              [userUnits]="userUnits"
            ></app-displacement-fluid-ipp>
          }
          @case (InternalPressureProfileType.PRESSURETEST) {
            <app-pressure-test-ipp
              [formControlName]="form.formControlNames.pressureTestIpp"
              [currentString]="currentString"
              [userUnits]="userUnits"
            ></app-pressure-test-ipp>
          }
          @case (InternalPressureProfileType.SSSV) {
            <app-sssv-ipp
              [formControlName]="form.formControlNames.sssvIpp"
              [currentString]="currentString"
              [userUnits]="userUnits"
            ></app-sssv-ipp>
          }
          @case (InternalPressureProfileType.GENERALFLUID) {
            <app-general-fluid-ipp
              [formControlName]="form.formControlNames.generalFluidIpp"
              [currentString]="currentString"
              [wellType]="wellType"
              [userUnits]="userUnits"
            ></app-general-fluid-ipp>
          }
          @case (InternalPressureProfileType.FULLEVAC) {
            <app-full-evac-ipp
              [formControlName]="form.formControlNames.fullEvacIpp"
              [currentString]="currentString"
              [userUnits]="userUnits"
            ></app-full-evac-ipp>
          }
          @case (InternalPressureProfileType.PARTIALEVAC) {
            <app-partial-evac-by-md-ipp
              [formControlName]="form.formControlNames.partialEvacByMdIpp"
              [currentString]="currentString"
              [userUnits]="userUnits"
              [currentStringMudWeight]="currentStringMudWeight"
            ></app-partial-evac-by-md-ipp>
          }
          @case (InternalPressureProfileType.WCDIPP) {
            <app-wcd-ipp
              [formControlName]="form.formControlNames.wcdIpp"
              [userUnits]="userUnits"
            ></app-wcd-ipp>
          }
          @case (InternalPressureProfileType.FLUIDDROP) {
            <app-fluid-drop-ipp
              [formControlName]="form.formControlNames.lostReturnsFluidDropIpp"
              [currentString]="currentString"
              [nextStringMudWeight]="nextStringMudWeight"
              [porePressures]="porePressures"
              [userUnits]="userUnits"
              [influxDepthRange]="influxFracDepthRange"
              [tubulars]="tubulars"
            ></app-fluid-drop-ipp>
          }
          @case (InternalPressureProfileType.LOSTRETURNSWATER) {
            <app-lost-returns-water-ipp
              [formControlName]="form.formControlNames.lostReturnsWaterIpp"
              [currentString]="currentString"
              [fracPressures]="fracPressures"
              [userUnits]="userUnits"
              [influxDepthRange]="influxFracDepthRange"
            ></app-lost-returns-water-ipp>
          }
          @case (InternalPressureProfileType.GASKICK) {
            <app-circulated-kick-gas-ipp
              [formControlName]="form.formControlNames.circulatedKickGasIpp"
              [currentString]="currentString"
              [nextStringMudWeight]="nextStringMudWeight"
              [fracPressures]="fracPressures"
              [smallestPipeId]="smallestPipeId"
              [userUnits]="userUnits"
              [tubulars]="tubulars"
              [fractureDepthDefault]="fractureDepthDefault"
              [influxDepthRange]="influxFracDepthRange"
            ></app-circulated-kick-gas-ipp>
          }
          @case (InternalPressureProfileType.LIQUIDKICK) {
            <app-circulated-kick-liquid-ipp
              [formControlName]="form.formControlNames.circulatedKickLiquidIpp"
              [currentString]="currentString"
              [nextStringMudWeight]="nextStringMudWeight"
              [fracPressures]="fracPressures"
              [smallestPipeId]="smallestPipeId"
              [userUnits]="userUnits"
              [tubulars]="tubulars"
              [fractureDepthDefault]="fractureDepthDefault"
              [influxDepthRange]="influxFracDepthRange"
            ></app-circulated-kick-liquid-ipp>
          }
          @case (InternalPressureProfileType.CUSTOMIPP) {
            <app-custom-ipp
              [formControlName]="form.formControlNames.customIpp"
              [currentString]="currentString"
              [userUnits]="userUnits"
              [wellTd]="wellTd"
              [defaultPressures]="defaultPressures"
            ></app-custom-ipp>
          }
          @case (InternalPressureProfileType.CFOG) {
            <app-casing-full-of-gas-ipp
              [formControlName]="form.formControlNames.cfogIpp"
              [userUnits]="userUnits"
              [currentString]="currentString"
              [fracPressures]="fracPressures"
              [porePressures]="porePressures"
              [tubulars]="tubulars"
              [fractureDepthDefault]="fractureDepthDefault"
              [influxDepthRange]="influxFracDepthRange"
            ></app-casing-full-of-gas-ipp>
          }
          @case (InternalPressureProfileType.GASOVERMUD) {
            <app-gas-over-mud
              [formControlName]="form.formControlNames.gasOverMudIpp"
              [userUnits]="userUnits"
              [currentString]="currentString"
              [fractureDepthDefault]="fractureDepthDefault"
              [influxDepthRange]="influxFracDepthRange"
              [nextStringMudWeight]="nextStringMudWeight"
              [tubulars]="tubulars"
              [fracPressures]="fracPressures"
              [porePressures]="porePressures"
              [wellheadDepth]="wellType?.wellheadDepthFromDrillFloor"
            ></app-gas-over-mud>
          }
          @case (InternalPressureProfileType.MUDOVERGAS) {
            <app-mud-over-gas
              [formControlName]="form.formControlNames.mudOverGasIpp"
              [userUnits]="userUnits"
              [currentString]="currentString"
              [fractureDepthDefault]="fractureDepthDefault"
              [influxDepthRange]="influxFracDepthRange"
              [nextStringMudWeight]="nextStringMudWeight"
              [tubulars]="tubulars"
              [fracPressures]="fracPressures"
              [porePressures]="porePressures"
              [wellheadDepth]="wellType?.wellheadDepthFromDrillFloor"
            ></app-mud-over-gas>
          }
        }
      </div>
    </p-panel>
  </form>
</app-tool-loader>
<!-- <pre>{{ form.formGroupErrors | json }}</pre> -->